import { Box } from 'src/design/atoms/Box';
import { Grid } from 'src/design/atoms/Grid';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { TextInput } from 'src/design/atoms/TextInput';
import React from 'react';
import { RateRequestDto } from 'src/api/FiretrolApiClient';
import { DeleteButton } from 'src/design/atoms/DeleteButton';

interface IListItemProps {
  rate: RateRequestDto;
  onRemove: () => void;
  includeTotal?: boolean;
  onQuanityChange: (value: RateRequestDto) => void;
}

export const ListItem: React.FC<IListItemProps> = ({
  rate,
  onRemove,
  onQuanityChange,
  includeTotal = false,
}) => {
  const [q, setQ] = React.useState(rate.quantity);
  React.useEffect(() => {
    onQuanityChange({ ...rate, quantity: q });
  }, [q]);
  if (includeTotal) {
    return (
      <Grid>
        <Grid.Col span={3}>
          <Box py="xs">{rate.label}</Box>
        </Grid.Col>
        <Grid.Col span={3} pt="xs">
          <TextInput
            placeholder="qty"
            value={q}
            onChange={(e) => {
              if (isNaN(Number(e.target.value)) && e.target.value !== '')
                return;
              setQ(e.target.value);
            }}
            rightSection={
              <BasicButton style={{ color: '#000' }} variant="subtle" disabled>
                {`${rate.rateMeasurement}s`}
              </BasicButton>
            }
          />
        </Grid.Col>
        <Grid.Col span={3} mt="xs">
          ${rate.rate1} / {rate.rateMeasurement}
        </Grid.Col>
        <Grid.Col span="auto" ta="right" mt="xs">
          ${(Number(rate.quantity) * Number(rate.rate1)).toLocaleString()}
        </Grid.Col>
        <Grid.Col span="auto" ta="right">
          <DeleteButton
            style={{ position: 'absolute', right: 10, top: 4 }}
            onClick={onRemove}
          />
        </Grid.Col>
      </Grid>
    );
  }
  return (
    <Grid>
      <Grid.Col span={5}>
        <Box py="xs">{rate.label}</Box>
      </Grid.Col>
      <Grid.Col span={5} pt="xs">
        <TextInput
          placeholder="qty"
          value={q}
          onChange={(e) => {
            if (isNaN(Number(e.target.value)) && e.target.value !== '') return;
            setQ(e.target.value);
          }}
          rightSection={
            <BasicButton style={{ color: '#000' }} variant="subtle" disabled>
              {`${rate.rateMeasurement}s`}
            </BasicButton>
          }
        />
      </Grid.Col>
      {includeTotal && (
        <Grid.Col span="auto" ta="right" mt="xs">
          ${(Number(rate.quantity) * Number(rate.rate1)).toLocaleString()}
        </Grid.Col>
      )}
      <Grid.Col span="auto" ta="right">
        <DeleteButton
          style={{ position: 'absolute', right: 10, top: 4 }}
          onClick={onRemove}
        />
      </Grid.Col>
    </Grid>
  );
};
